export const stateContext = "currentUser";

export enum Permission {
  VIEW = "VIEW",
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  FULL_VIEW = "FULL_VIEW",
  FULL_CREATE = "FULL_CREATE",
  FULL_UPDATE = "FULL_UPDATE",
  FULL_DELETE = "FULL_DELETE",
  APPROVE = "APPROVE",
  CONFIRM = "CONFIRM",
  // PUBLISH = 9,
  // PRIVATE_BOOKING = 10,
  // PUBLIC_BOOKING = 11,
}

export const permissionDict = {
  [Permission.VIEW]: "View",
  [Permission.CREATE]: "Create",
  [Permission.UPDATE]: "Update",
  [Permission.DELETE]: "Delete",
  [Permission.APPROVE]: "Approve",
  [Permission.CONFIRM]: "Confirm",
};

export enum Resource {
  CAMPAIGN_PARTNER = "CAMPAIGN_PARTNER",
  META = "META",
  USER = "USER",
  CATEGORY = "CATEGORY",
  CAPACITY = "CAPACITY",
  ROLE = "ROLE",
  CAMPAIGN_UNIVERSAL = "CAMPAIGN_UNIVERSAL",
  COMMISSION = "COMMISSION",
  COUPON = "COUPON",
  PROGRAM = "PROGRAM_MANAGE",
  INVOICE = "INVOICE",
  PAYMENT = "PAYMENT",
  ADVERTISER_INVOICE = "ADVERTISER_INVOICE",
  ADVERTISER_PAYMENT = "ADVERTISER_PAYMENT",
  CONTRACT = "CONTRACT",
  USER_CONTRACT = "USER_CONTRACT",
  DASHBOARD = "DASHBOARD",
  SYSTEM_CONFIGURATION = "SYSTEM_CONFIGURATION",
  REPORT = "REPORT",
  PENDING_USER = "PENDING_USER",
  WALLET = "WALLET",
  ADVERTISER_CONTRACT = "ADVERTISER_CONTRACT",
  USER_ADVERTISER_CONTRACT = "USER_ADVERTISER_CONTRACT",
  CHAT_AGENT = "CHAT_AGENT",
  SUB_USER = "SUB_USER",
  SHARE_ACCESS = "SHARE_ACCESS",
  SHARE_ACCESS_MANAGEMENT = "SHARE_ACCESS_MANAGEMENT",
  GROUP = "GROUP",
  WEBSITE_CONFIGURATION = "WEBSITE_CONFIGURATION",
  AD_NETWORK_PUBLISHER = "AD_NETWORK_PUBLISHER",
  DEAL_MANAGE = "DEAL_MANAGE",
  TOPUP = "AFF_TOPUP",
}

export const resourceDict = {
  [Resource.CAMPAIGN_PARTNER]: "Campaign Partner",
  [Resource.META]: "Meta",
  [Resource.CATEGORY]: "Category",
  [Resource.CAPACITY]: "Capacity",
  [Resource.CAMPAIGN_UNIVERSAL]: "Campaign Universal",
  [Resource.COMMISSION]: "Commission",
  [Resource.USER]: "User",
  [Resource.ROLE]: "Role",
  [Resource.PROGRAM]: "Program Manager",
  [Resource.ADVERTISER_INVOICE]: "Advertiser Invoice",
  [Resource.ADVERTISER_PAYMENT]: "Advertiser Payment",
  [Resource.CONTRACT]: "Contract",
  [Resource.USER_CONTRACT]: "User Contract",
  [Resource.DASHBOARD]: "Dashboard",
  [Resource.REPORT]: "Report",
  [Resource.PENDING_USER]: "Pending User",
  [Resource.ADVERTISER_CONTRACT]: "Contract Advertiser",
  [Resource.USER_ADVERTISER_CONTRACT]: "User Contract Advertiser",
  [Resource.CHAT_AGENT]: "Chat Agent",
  [Resource.SUB_USER]: "Sub User",
  [Resource.SHARE_ACCESS]: "Share Access",
  [Resource.SHARE_ACCESS_MANAGEMENT]: "Share Access Management",
  [Resource.WEBSITE_CONFIGURATION]: "Website Configuration",
};

export const resources = [
  Resource.CAMPAIGN_PARTNER,
  Resource.CAMPAIGN_UNIVERSAL,
  Resource.META,
  Resource.CATEGORY,
  Resource.CAPACITY,
  Resource.COMMISSION,
  Resource.USER,
  Resource.ROLE,
  Resource.PROGRAM,
  Resource.ADVERTISER_INVOICE,
  Resource.ADVERTISER_PAYMENT,
  Resource.CONTRACT,
  Resource.USER_CONTRACT,
  Resource.DASHBOARD,
  Resource.REPORT,
  Resource.PENDING_USER,
  Resource.ADVERTISER_CONTRACT,
  Resource.USER_ADVERTISER_CONTRACT,
  Resource.CHAT_AGENT,
  Resource.SUB_USER,
  Resource.SHARE_ACCESS,
  Resource.SHARE_ACCESS_MANAGEMENT,
  Resource.WEBSITE_CONFIGURATION,
];

export enum UserStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  UNDERREVIEW = "UNDERREVIEW",
}

export enum UserType {
  SELLER = "SELLER",
  KOL = "KOL",
  AFFILIATOR = "AFFILIATOR",
  PARTNER = "PARTNER",
  OPERATOR = "OPERATOR",
  ALL = "ALL",
}
